import { render, staticRenderFns } from "./detail_suppliers_page.vue?vue&type=template&id=69261b0b&scoped=true"
import script from "./detail_suppliers_page.vue?vue&type=script&lang=js"
export * from "./detail_suppliers_page.vue?vue&type=script&lang=js"
import style0 from "./detail_suppliers_page.vue?vue&type=style&index=0&id=69261b0b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69261b0b",
  null
  
)

export default component.exports